/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
	'ptc.pm.collaborators.title': 'Vaši spolupracovníci',
	'ptc.pm.error-heading': 'Vyskytla sa chyba',
	'ptc.pm.error-image-alt-text':
		'Robot sa pokazil. Niekoľko ľudí sa ho teraz usilovne snaží opraviť.',
	'ptc.pm.error-text':
		'Tieto chyby sledujeme, ale neváhajte nás kontaktovať, ak sa vám problém nepodarí vyriešiť tým, že znova načítate stránku.',
	'ptc.pm.people': 'Ľudia',
	'ptc.pm.start-a-team': 'Založiť tím',
	'ptc.pm.view-your-profile': 'Zobraziť váš profil',
	'ptc.pm.your-teams.title': 'Vaše tímy',
};
